import React from 'react'
import { Tag } from 'antd'
import { Dimension } from '../../../../../features/dimension/types/Dimension'
import { isOwnSource, tagLabel } from '../utils/dimensionAccess'

interface DimensionSourceTagProps {
  dimension: Dimension
}

const DimensionSourceTag: React.FC<DimensionSourceTagProps> = ({ dimension }) => (
  <Tag color={isOwnSource(dimension.source) ? 'blue' : undefined}>{tagLabel(dimension.source)}</Tag>
)

export default DimensionSourceTag
